import React, { useRef } from 'react';
import cx from 'classnames';
import styles from './input.css';
import { HighlightButton } from 'components/common/button';
export const TextInput = props => {
    const { theRef, ...rest } = props;
    return (React.createElement("input", Object.assign({ ref: theRef, type: "text" }, rest, { className: cx(styles.textInput, props.className) })));
};
export const TextAreaInput = props => {
    const { theRef, ...rest } = props;
    return React.createElement("textarea", Object.assign({ ref: theRef }, rest, { className: cx(styles.textInput, props.className) }));
};
export const InputGroup = props => {
    return React.createElement("div", { className: styles.inputGroup }, props.children);
};
export const TextInputActionGroup = props => {
    const inputRef = useRef(null);
    return (React.createElement("div", { className: cx(styles.textInputActionGroup, props.className) },
        React.createElement("input", { ref: inputRef, className: cx(props.inputClassName, styles.textInput), type: "text", defaultValue: props.defaultValue, disabled: props.disabled, placeholder: props.placeholder, pattern: props.pattern }),
        React.createElement(HighlightButton, { icon: props.actionIcon, onClick: props.onAction
                ? () => {
                    if (props.onAction) {
                        props.onAction(inputRef.current);
                    }
                }
                : undefined, highlight: props.highlight }, props.actionLabel)));
};
